module.exports = __webpack_public_path__ + "static/media/score_heatmap_1.a45a1aaa.png";